import * as go from 'gojs';

import {
  GRID_BACKGROUND_COLOR,
  GRID_LINE_COLOR,
  GRID_SIZE,
  GRID_WIDTH,
} from 'src/containers/ProjectDiagram/constants/styles';
import { ExtendedDiagram } from 'src/containers/ProjectDiagram/templates/extensions/diagram';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';

/**
 * Create a new background grid for use in a diagram.
 */
export const createGrid = () => {
  return new go.Panel('Grid', {
    background: GRID_BACKGROUND_COLOR,
    gridCellSize: new go.Size(GRID_SIZE, GRID_SIZE),
  }).add(
    new go.Shape('LineH', {
      stroke: GRID_LINE_COLOR,
      strokeWidth: GRID_WIDTH,
    }),
    new go.Shape('LineV', {
      stroke: GRID_LINE_COLOR,
      strokeWidth: GRID_WIDTH,
    })
  );
};

/**
 * Recreate the diagram's grid and update it to ensure the grid rerenders.
 * This is helpful in cases like the diagram region resizing and the grid
 * otherwise not updating appropriately.
 */
export const updateGrid = (diagram: ExtendedDiagram) => {
  commitDiagramWhileSkippingUndoManager(diagram, (_model, diagram) => {
    // eslint-disable-next-line no-param-reassign
    diagram.grid = createGrid();
  });
};
